import { useLogistiFiling } from './useLogistiFiling';

/**
 * Does the signed-in tenant file government waybills through Logisti (Bayan)?
 *
 * A thin read of {@link useLogistiFiling} kept for the load-form callers, whose
 * question really is "connected" and not "can issue today": goods value and
 * cargo type have to be Bayan-valid on a load that will be filed next week, not
 * only on one that could be filed this second.
 *
 * Now `true` for tenants filing on Hero's licence, which it never was before —
 * they had no install row to read. That is the intended fix and it does change
 * load-form behaviour for tenants who never opened the integrations screen: the
 * data their documents already need is finally required at entry rather than
 * discovered at issuance.
 */
export const useIsLogistiConnected = (): boolean => useLogistiFiling().isConnected;
